import { Component } from "@angular/core"

import {
  Location,
} from "@angular/common"
import { Router } from "@angular/router"

@Component({
  moduleId: module.id,
  selector: "tr-footer",
  templateUrl: "footer.component.html",
})
export class FooterComponent {
  public location: Location
  public test: Date = new Date()

  constructor(location: Location, private router: Router) {
    this.location = location
  }

  public getPath(): string {
    return this.location.prepareExternalUrl(this.location.path())
  }

  public isTester(): boolean {
    const path = this.getPath()
    if (path.startsWith("/tester")) {
      return true
    }
    return false
  }

  public isManager(): boolean {
    const path = this.getPath()
    if (path.startsWith("/captain")) {
      return true
    }
    return false
  }

  public isSuper(): boolean {
    const path = this.getPath()
    if (path.startsWith("/super")) {
      return true
    }
    return false
  }
}
